const { docToEntity } = require('./../../tools')

// If `unfiltered` is true, we should not filter by the user's programs.
exports.listPrograms = async function (state, { unfiltered } = {}) {
  const doc = await state.dal.program.getPrograms(state)
  if (unfiltered) {
    return docToEntity(doc, false)
  }
  return docToEntity(doc, true, state.user.programs)
}
